import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { AffAuthFrame } from "../../components/affiliate/AffAuthFrame";
import { affApi, affToken } from "../../lib/affApi";
import { fmtErr } from "../../lib/api";

export default function AffiliateLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr(null);
    try {
      const { data } = await affApi.post("/affiliate/login", { email, password });
      affToken.set(data.access_token);
      nav("/affiliate/dashboard", { replace: true });
    } catch (e2) {
      const d = e2?.response?.data?.detail;
      if (d && typeof d === "object" && d.code === "requires_verification") {
        nav(`/affiliate/verify?email=${encodeURIComponent(d.email)}`);
        return;
      }
      setErr(fmtErr(e2));
    } finally { setBusy(false); }
  };

  return (
    <AffAuthFrame title="Partner sign in" subtitle="Your affiliate dashboard — earnings, customers, payouts." testId="aff-login-page">
      <form onSubmit={submit} className="space-y-4" data-testid="aff-login-form">
        <div><Label htmlFor="email">Email</Label><Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="aff-login-email" /></div>
        <div>
          <div className="flex items-center justify-between"><Label htmlFor="pwd">Password</Label><Link to="/affiliate/forgot-password" className="text-xs text-zinc-600 underline" data-testid="aff-link-forgot">Forgot?</Link></div>
          <Input id="pwd" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="aff-login-password" />
        </div>
        {err && <div className="text-sm text-red-600" data-testid="aff-login-error">{err}</div>}
        <Button type="submit" disabled={busy} className="w-full bg-ink hover:bg-black" data-testid="aff-login-submit">{busy ? "Signing in…" : "Sign in"}</Button>
        <p className="text-sm text-zinc-600 text-center">New here? <Link to="/affiliate#signup" className="underline text-ink" data-testid="aff-link-signup">Join the program</Link></p>
      </form>
    </AffAuthFrame>
  );
}
